import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=6228b6f4&scoped=true&"
import script from "./UpgradeCard.vue?vue&type=script&lang=js&"
export * from "./UpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=6228b6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228b6f4",
  null
  
)

export default component.exports